<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="copy">©2023 William R. Cobb, Editor</p>
<p class="copyt">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior written permission of the publisher.</p>
<p class="copyt">First Edition, First Printing</p>
<p class="copyt">Library of Congress Control Number: 2022949790</p>
<p class="copyt">ISBN-13: 978-1-61121-514-4</p>
<p class="copy">eISBN: 978-1-94066-996-0</p>
<div class="img_containerc">
<img alt="images" src="images/copy.jpg"/>
</div>
<p class="copy">Savas Beatie</p>
<p class="copy">989 Governor Drive, Suite 102</p>
<p class="copy">El Dorado Hills, CA 95762</p>
<p class="copy">Phone: 916-941-6896 / <span class="weblink"><a href="mailto:sales@savasbeatie.com"><span class="underline">sales@savasbeatie.com</span></a></span></p>
<p class="copyt">Savas Beatie titles are available at special discounts for bulk purchases in the United States. Contact us for more details.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?270e08e8